// React Imports
import React, {useEffect, useRef, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from "@mui/material/Box";
import {Avatar, InputLabel, Select, Stack, Typography} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";

// App Imports
import { getContractProductsTopLevel} from "../../ExternalData/Product/ProductClient";
import {changeWorkQueue} from "../workQueueSlice";
import {changeWork} from "../../Work/workSlice";
import {changeContractStats} from "../WorkStats/contractStatsSlice";
import {changeContractStatsControls} from "../WorkStats/contractStatsControlsSlice";
import RefreshIcon from "@mui/icons-material/Refresh";
import {Tooltip} from "recharts";


// main function
export default function WorkQueuePropertyDropdownList() {

    const {register, handleSubmit} = useForm();
    const [productDropdown, setProductDropdown] = useState([]);
    const [productTopLevelDropdown, setProductTopLevelDropdown] = useState([]);
    const selectorPropertyDropdownTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const [productTopLevelValue, setProductTopLevelValue] = useState(
        Number(selectorPropertyDropdownTitleId) || 0
    );

    const [guildDropdown, setGuildDropdown] = useState([]);
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [productValue, setProductValue] = useState(useSelector((state) => state.obligationHierarchySlc.value.myProductId));
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState([]);
    const [selectedTopLevelProduct, setSelectedTopLevelProduct] = useState([]);
    const [selectedProductTopLevel, setSelectedProductTopLevel] = useState([]);
    // const [selectedProduct, setSelectedProduct] = useState([]);
    const dispatchData = useDispatch();

    const handleClearClick = () => {
        setProductValue("");
        setGuildValue("");
        setR2mValue("");
    };


    const handleClearProductTopLevelClick = () => {
        setProductValue("");
        setProductTopLevelValue ("");
        dispatchData(changeWorkQueue({propertyDropdownTitleId: 0}));
        console.log("propertyDropdownTitleId modified to equal 0 ");
        dispatchData(changeWorkQueue({
            selectedContractId: 0,
            selectedContractName: null,
            selectedContractLevel: null,
            selectedContractProductId: null,
            selectedContractType: null,
            selectedContractGuild: null,
            selectedContractFailedExpressionCount: null,
            selectedContractFailedFilterCount: null,
            selectedContractInputMissingCount: null,
            selectedContractPropertyId: null,
            selectedContractStatus: null,
            selectedContractDescription: null,
            bigAddButtonDisplay: true
        }));
        dispatchData(changeWork({
            propertyId: null}));
    };


    const handleClearR2mClick = () => {
        setR2mValue("");
    };

    const fetchContractProductsTopLevel = () => {
        handleClearProductTopLevelClick;
        setProductTopLevelValue(null);
        getContractProductsTopLevel()

            .then(data => {
                console.log("top Level Product Dropdown Data")
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setProductTopLevelDropdown(data);
            })
    }


    useEffect(() => {
        console.log("This is for the product dropdown...");
        fetchContractProductsTopLevel();
    }, []);


    useEffect(() => {
        console.log("resetting top level product value");
        setProductTopLevelValue(selectorPropertyDropdownTitleId);
    }, [selectorPropertyDropdownTitleId]);


    const handleProductTopLevelChange = (prod2) => {
        // setSelectedProduct(dropdownProducts.target.seriesId);
        dispatchData(changeWorkQueue({workQueueCGridAbstractRefresh: false, bigAddButtonDisplay: false      }));
        console.log("The selected Property in the dropdown menu has changed.");
        console.log("This is the new data for the selected Top Level Product");
        console.log(prod2);
        console.log("selectedTopLevelProduct");
        console.log(productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2));
        // console.log(productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === parseInt(prod2)).expansionDepth);
        // dispatchData(changeWork({propertyId: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod2)).id,
        //     expansionDepth: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod2)).expansionDepth}));
        setSelectedTopLevelProduct(productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2));
        console.log(productTopLevelDropdown[0]);

        dispatchData(changeWorkQueue({
            propertyDropdownTitleId: prod2,
            propertyDropdownTitle: productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2).title,
            propertyDropdownMultiSingle: productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2).multiSingle,
            propertyDropdownExpansionDepth: productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2).expansionDepth,
            workQueueCGridRefresh: true}));

        dispatchData(changeWorkQueue({
            selectedContractId: 0,
            selectedContractName: null,
            selectedContractLevel: null,
            selectedContractProductId: null,
            selectedContractType: null,
            selectedContractGuild: null,
            selectedContractFailedExpressionCount: null,
            selectedContractFailedFilterCount: null,
            selectedContractInputMissingCount: null,
            selectedContractPropertyId: null,
            selectedContractStatus: null,
            selectedContractDescription: null
        }));

if(productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2).multiSingle === "multi")
{console.log("multi stats triggered.");
    console.log("seriesId:", prod2);
    console.log("expansion depth: 6");
    dispatchData(changeWork({expansionDepth: 5}));
    dispatchData(changeContractStats({seriesId: prod2, seriesTitle: null,
            seasonId: null, seasonName: null, productId: null, episodeName: null, photoStartDate: null}));
        dispatchData(changeContractStatsControls({gridDisplay: "SeasonRightPanel",gridRefresh: true}));

        }

if(productTopLevelDropdown.find(productTopLevelDropdown => productTopLevelDropdown.id === prod2).multiSingle === "single")
        {console.log("single stats triggered.");
            console.log("productId: ", prod2);
            console.log("expansion depth: 4");
            dispatchData(changeWork({expansionDepth: 3}));
            dispatchData(changeContractStats({seriesId: null, seriesTitle: null,
            seasonId: null, seasonName: null, productId: prod2, episodeName: null, photoStartDate: null}));
            dispatchData(changeContractStatsControls({gridDisplay: "ProductRightPanel",gridRefresh: true}));}
        // console.log(productDropdown.filter(productDropdown => productDropdown.productId === data.my_product_id));

    };



    function onSubmit(data) {
        console.log("here's my obligation/payment/fringe search data before I submit it ")
        console.log({data})
        setSelectedProduct(productDropdown.filter(productDropdown => productDropdown.productId = data.my_product_id));
        console.log("selectedProduct");
        // console.log(productDropdown.filter(productDropdown => productDropdown.productId  === 1001));
        console.log(productDropdown.filter(productDropdown => productDropdown.productId === data.my_product_id));
        // dispatchData(changeWork({propertyId: data.my_product_id, propertyLevel: productDropdown.filter(productDropdown => productDropdown.productId = data.myProductId)});
        dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
        // dispatchData(changeBulkEditControls({ bulkEditGridRefresh: true}));
        // dispatchData(changeWork({
        //             propertyId: data.my_product_id
        //
        //         }));
    };



    const searchForm  = () => (
        <form

            onSubmit={handleSubmit((data)=>onSubmit(data))}
        >
            <Box
                sx={{ width: 600 , height: 60, pl: 1}}
                role="presentation"
            >


                <Stack direction={"row"} spacing={2} alignItems="center">
                    {/*<h2> Search</h2>*/}
                    <RefreshIcon  color={'primary'}  style={{cursor:'pointer'}}
                                  onClick={() => {fetchContractProductsTopLevel()}}
                    />
                    <Box >
                        <FormControl variant="standard" sx={{  minWidth: 600 }}>
                            <InputLabel htmlFor="contractProductTopLevel.id"  onClick={handleClearProductTopLevelClick}>Property</InputLabel>
                            <Select
                                {...register('my_title_id', { required: true })}
                                id="my_title_id"
                                value={productTopLevelValue}
                                onChange={(event) => {
                                    setProductTopLevelValue(event.target.value);
                                    handleProductTopLevelChange(event.target.value);
                                }}
                                renderValue={(selected) => {
                                    const productItem = productTopLevelDropdown.find(
                                        (item) => item.id === selected
                                    );

                                    if (!productItem) return '';

                                    return (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1,
                                            flexWrap: 'nowrap',
                                            minWidth: 0 }}>
                                            <Typography noWrap sx={{ minWidth: 0 }}>
                                                {productItem.title}
                                            </Typography>

                                            {productItem.participantCount > 0 && (
                                                <Avatar variant="rounded"  sx={{
                                                    height: 20,
                                                    width: 20,
                                                    fontSize: 16,
                                                    bgcolor: "rgb(30,144,255)"
                                                }}>
                                                    Pa
                                                </Avatar>
                                            )}

                                            {productItem.guildIdList !== '' && (
                                                // <Tooltip title={productItem.guildNameList}>
                                                    <Box component="span" sx={{ display: 'inline-flex', flexShrink: 0 }}>
                                                <Avatar variant="rounded"  sx={{
                                                    height: 20,
                                                    width: 20,
                                                    fontSize: 16,
                                                    // bgcolor: "rgb(30,144,255)"
                                                    bgcolor: "green"
                                                }}>
                                                    Re
                                                </Avatar>
                                                    </Box>
                                                // </Tooltip>
                                            )}
                                        </Box>
                                    );
                                }}
                            >
                                {productTopLevelDropdown.map((productItem) => (
                                    <MenuItem
                                        key={productItem.id}
                                        value={productItem.id}
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                    >
                                        {productItem.title}

                                        {productItem.participantCount > 0 && (
                                            <Avatar  variant="rounded"
                                                sx={{
                                                    ml: 1,
                                                    height: 20,
                                                    width: 20,
                                                    fontSize: 16,
                                                    bgcolor: 'rgb(30,144,255)',

                                                    flexShrink: 0
                                                }}
                                            >
                                                Pa
                                            </Avatar>
                                        )}

                                        {productItem.guildIdList !== '' && (
                                            <Avatar
                                                variant="rounded"
                                                title={productItem.guildNameList || ''}
                                                sx={{
                                                    ml: 1,
                                                    height: 20,
                                                    width: 20,
                                                    fontSize: 16,
                                                    bgcolor: 'green',
                                                    flexShrink: 0,
                                                    cursor: 'help'
                                                }}
                                            >
                                                Re
                                            </Avatar>
                                        )}
                                    </MenuItem>
                                ))}

                                {/*{productTopLevelDropdown.map((productItem) => (*/}
                                {/*    <MenuItem key={productItem.id} value={productItem.id}>*/}
                                {/*        {productItem.title}*/}

                                {/*        {productItem.participantCount > 0 && (*/}
                                {/*            <Avatar variant="rounded"  sx={{*/}
                                {/*                ml: 1,*/}
                                {/*                height: 20,*/}
                                {/*                width: 20,*/}
                                {/*                fontSize: 16,*/}
                                {/*                bgcolor: "rgb(30,144,255)"*/}
                                {/*            }}>*/}
                                {/*                Pa*/}
                                {/*            </Avatar>*/}
                                {/*        )}*/}

                                {/*        {productItem.guildIdList !== '' && (*/}
                                {/*            <Tooltip*/}
                                {/*                title={productItem.guildNameList}*/}
                                {/*                // title={"Residuals"}*/}

                                {/*                arrow*/}
                                {/*                placement="right"*/}
                                {/*            >*/}
                                {/*                <Avatar variant="rounded"  sx={{*/}
                                {/*                    ml: 1,*/}
                                {/*                    height: 20,*/}
                                {/*                    width: 20,*/}
                                {/*                    fontSize: 16,*/}
                                {/*                    bgcolor: "green",*/}
                                {/*                    flexShrink: 0*/}
                                {/*                }}>*/}
                                {/*                    Re*/}
                                {/*                </Avatar>*/}
                                {/*            </Tooltip>*/}
                                {/*        )}*/}
                                {/*    </MenuItem>*/}
                                {/*))}*/}
                            </Select>

                            {/*<Select*/}
                            {/*    {...register('my_title_id', { required: true })}*/}
                            {/*    isClearable={true}*/}
                            {/*    id="my_title_id"*/}
                            {/*    onChange={(newProductTopLevelValue) => {*/}
                            {/*        setProductTopLevelValue(newProductTopLevelValue.target.value);*/}
                            {/*        console.log(newProductTopLevelValue.target.value);*/}
                            {/*        handleProductTopLevelChange(newProductTopLevelValue.target.value);*/}
                            {/*        // handleProductTopLevelChange(newProductTopLevelValue.target);*/}
                            {/*    }}*/}
                            {/*    // type= "submit"*/}
                            {/*    defaultValue=  {productTopLevelValue}*/}
                            {/*    value = {productTopLevelValue}*/}
                            {/*>*/}
                            {/*    {productTopLevelDropdown.map((productItem) =>*/}
                            {/*        <MenuItem*/}
                            {/*            value={productItem.id}*/}

                            {/*        >{productItem.title} {productItem.participantCount > 1 &&  <Avatar sx={{ ml: 1, height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Pa</Avatar>}*/}
                            {/*            {productItem.guildIdList !== '' &&  <Avatar sx={{ml: 1, height: 20, width: 20, fontSize: 16, bgcolor: "green"}}>Re</Avatar>}</MenuItem>*/}
                            {/*    )}*/}
                            {/*</Select>*/}

                        </FormControl>

                    </Box>

                    {/*<Button*/}
                    {/*    type= "submit"*/}
                    {/*>Retrieve</Button>*/}
{/*<p>top level product {selectorPropertyDropdownTitleId}</p>*/}
{/*<p>selectorPropertyDropdownTitleId {selectorPropertyDropdownTitleId}</p>*/}
                </Stack>
            </Box>

        </form>
    );

    return (
        <div>
            {searchForm()}
        </div>

    )


}

